"use client";
import React from "react";
import { Chip } from "@mui/material";

export interface PublisherCardProps {
  publisher: string | null;
}

/** Tiny chip showing the package publisher. Renders nothing when the
 *  manifest doesn't declare a publisher (legacy Ring-3 packages). A
 *  future PR can add a verified badge here. */
export function PublisherCard({ publisher }: PublisherCardProps) {
  if (!publisher) return null;
  return (
    <Chip
      label={`by ${publisher}`}
      size="small"
      variant="outlined"
      aria-label={`publisher-${publisher}`}
    />
  );
}
